import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../../hooks/hooks';
import storePersist from '../../../../../../redux/storePersist';
import PageLoader from '../../../../../../components/PageLoader';
import TasksComponent from '../components/tasks.component';
import { tasks } from '../../../../../../redux/tasks/action';
import { contacts } from '../../../../../../redux/contacts/action';
import { leads } from '../../../../../../redux/leads/action';
import { selectLeadsListItems } from '../../../../../../redux/leads/selector';
import { accounts } from '../../../../../../redux/accounts/action';
import { opportunities } from '../../../../../../redux/opportunities/action';
import { selectAccountsListItems } from '../../../../../../redux/accounts/selector';
import { selectCrmtasksQueryItems } from '../../../../../../redux/crm-tasks/selector';
import { selectCrmcontactsListItems } from '../../../../../../redux/crm-contacts/selector';
import { selectRelatedToTypesListItems } from '../../../../../../redux/related-to-types/selector';
import { relatedToTypes } from '../../../../../../redux/related-to-types/action';
import { crmtasks } from '../../../../../../redux/crm-tasks/action';
import { selectOpportunitiesListItems } from '../../../../../../redux/opportunities/selector';

const CrmTask = () => {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const parmas: any = useParams()
    const queryItems = useSelector(selectCrmtasksQueryItems)
    const libraryListItems = storePersist.get("library")?.current;
    const sourceTypeListItems = useSelector(selectRelatedToTypesListItems)
    const relatedToTypeListItems = useSelector(selectRelatedToTypesListItems)
    const contactsListItems = useSelector(selectCrmcontactsListItems)
    const leadsListItems = useSelector(selectLeadsListItems)
    const accountsListItems = useSelector(selectAccountsListItems)
    const opportunityListItems = useSelector(selectOpportunitiesListItems)
    const [isQuery, setIsQuery] = useState<boolean>(false)
    const [isLoading, setIsLoading] = useState<boolean>(true)
    const [selectedTasks, setSelectedTasks] = useState<any>()

    const fetchTaskById = () => {
        dispatch(crmtasks.query({
            url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/sales/crm/tasks/query`,
            entity: 'tasks',
            jsonData: {
                Records: [
                    {
                        "Id": parmas?.id
                    }
                ]
            }
        })).then(() => {
            setIsQuery(true)
        })
    }

    const handleInnerFormChange: any = (event: any, field: string) => {
        setSelectedTasks({ ...selectedTasks, [field]: event })
    }

    useEffect(
        () => {
            dispatch(relatedToTypes.list({
                url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/crm/related-to-types/list`,
                entity: 'relatedToTypes',
                jsonData: {
                    Records: [
                        {
                            SourceTypeId: 13
                        }
                    ]
                },
            })).then(() => {
                dispatch(contacts.list({
                    url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/sales/crm/contacts/list`,
                    entity: 'contacts',
                    jsonData: {}
                }))
            }).then(() => {
                dispatch(leads.list({
                    url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/sales/crm/leads/list`,
                    entity: 'leads',
                    jsonData: {}
                }))
            }).then(() => {
                dispatch(accounts.list({
                    url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/rms/accounts/list`,
                    entity: 'accounts',
                    jsonData: {}
                }))
            }).then(() => {
                dispatch(opportunities.list({
                    url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/sales/crm/opportunities/list`,
                    entity: 'opportunities',
                    jsonData: {}
                }))
            }).then(() => {
                if (parmas?.id > 0) {
                    fetchTaskById()
                    setIsLoading(false)
                } else {
                    setIsLoading(false)
                }
            })
        },
        []
    )

    useEffect(
        () => {
            if (isQuery) {
                setSelectedTasks(queryItems?.result?.items)
            }
        },
        [isQuery]
    )

    const handleFormSubmit = async (event: any) => {
        event.preventDefault();
        if (parmas?.id > 0) {
            await dispatch(crmtasks.resetAction({ actionType: 'update' }))
            await dispatch(crmtasks.update({
                url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/sales/crm/tasks`,
                entity: 'crmtasks',
                jsonData: {
                    Records: [
                        {
                            ...selectedTasks
                        }
                    ]
                }
            })).then(() => {
                back()
            })

        } else {
            await dispatch(crmtasks.resetAction({ actionType: 'create' }))
            await dispatch(crmtasks.create({
                url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/sales/crm/tasks`,
                entity: 'tasks',
                jsonData: {
                    Records: [
                        {
                            ...selectedTasks
                        }
                    ]
                }
            })).then(() => {
                back()
            })
        }
    }

    const back = () => {
        navigate('/management/sales/crm/tasks')
    }

    return (
        <>
            {isLoading ? <PageLoader /> :
                <TasksComponent
                    handleInnerFormChange={handleInnerFormChange}
                    selectedTasks={selectedTasks}
                    back={back}
                    handleFormSubmit={handleFormSubmit}
                    taskStatus={libraryListItems.TaskStatus}
                    sourceType={sourceTypeListItems?.result?.items}
                    contacts={contactsListItems?.result?.items}
                    leads={leadsListItems?.result?.items}
                    relatedToTypes={relatedToTypeListItems?.result?.items}
                    opportunities={opportunityListItems?.result?.items}
                    campaign={libraryListItems?.CampaignType}
                    accounts={accountsListItems?.result?.items}
                />
            }
        </>
    )
}

export default CrmTask;